/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

const getListItem = (state, key) => {
    return state
        .analysis
        .data[key]
        .line_items
        .find(i => i.index === state.analysis.selectedItem.index)
}

const RESET_STATE = state => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

const CHANGE_STEP = (state, step) => {
    state.selectedStep = step
}

const SET_FILE_DATA = (state, payload) => {
    state.data[payload.type].data = payload.data
}

const SET_UPLOADING = state => {
    state.upload.active = true
}

const RESET_UPLOADING = state => {
    state.upload.active = false
}

const SET_UPLOAD_ERROR = (state, payload) => {
    state.upload.error = payload
}

const UPLOAD_SUCCESS = state => {
    state.upload.success = true
}

const UPLOAD_FAILED = state => {
    state.upload.success = false
}

const REQUEST_FILE_ASSISTANCE = state => {
    state.upload.requestingAssistance = true
}

const SUPPORT_REQUEST_SUCCESS = state => {
    state.upload.fileAssisted = true
    state.upload.requestingAssistance = false
}

const SUPPORT_REQUEST_FAILURE = state => {
    state.upload.fileAssisted = false
    state.upload.requestingAssistance = false
}

const SET_CONTEXT = (state, context) => {
    state.context = context
}

const SET_ANALYSIS_DATA = (state, data) => {
    state.analysis.data = data
}

const SET_ANALYSIS_LOADING = state => {
    state.analysis.loading = false
}

const RESET_ANALYSIS_LOADING = state => {
    state.analysis.loading = false
}

const SET_ANALYSIS_ERROR = state => {
    state.analysis.error = true
}

const UPDATE_FILTER_VALUE = (state, value) => {
    state.analysis.filterTerm = value
}

const CHANGE_ACTIVE_ITEM = (state, payload) => {
    state.analysis.selectedItem = payload
}

const SET_CURRENT_TIMEFRAME = (state, timeframe) => {
    state.analysis.selectedItem.time_frame = timeframe
}

const UPDATE_ANNUALIZED_AMOUNTS = (state, payload) => {
    const types = ['miscinc', 'opex']
    state.analysis.selectedItem.annualized_amounts = payload.annualized_amounts
    types.forEach(type => {
        state.analysis.data[type].line_items.forEach(i => {
            if (i.index === payload.index) {
                i.annualized_amounts = payload.annualized_amounts
            }
        })
    })
}

const SET_IMPORT_SUCCESS = state => {
    state.imported_success = true
}

const UPDATE_LINE_ITEM_VALUE = (state, payload) => {
    const obj = getListItem(state, 'opex') || getListItem(state, 'miscinc')
    state.analysis.selectedItem.values[payload.dataIndex].adjusted = payload.value
    obj.values[payload.dataIndex].adjusted = payload.value === obj.values[payload.dataIndex].file
        ? null
        : payload.value
}

const RESET_ANALYSIS_STATE = state => {
    state.analysis = {
        loading: false,
        error: false,
        activeKey: 'opex',
        filterTerm: null,
        selectedItem: {},
        data: {
            meta: {
                time_frames: []
            },
            miscinc: {
                general: [],
                line_items: []
            },
            opex: {
                general: [],
                line_items: []
            }
        }
    }
}

const TOGGLE_INPUT_BINDINGS = state => {
    state.classification.showInputBindings = !state.classification.showInputBindings
}

const PAGINATE_FORWARD = state => {
    state.data.rentroll.pagination.currentPage++
}

const PAGINATE_BACKWARD = state => {
    state.data.rentroll.pagination.currentPage--
}

const PAGINATE_FIRST = state => {
    state.data.rentroll.pagination.currentPage = 1
}

const PAGINATE_LAST = state => {
    let rows = state.data.rentroll.data.table_data.meta.number_of_rows + 1
    let limit = state.data.rentroll.pagination.pageLimit

    state.data.rentroll.pagination.currentPage = Math.ceil(rows / limit)
}

const CHANGE_TAB = (state, tab) => {
    state.data.rentroll.showTab = tab
}

const LOAD_NEW_MAPPING = (state, payload) => {
    state.data.rentroll.data.summary = payload.summary
    state.data.rentroll.data.table_data = payload.table_data
    state.data.rentroll.data.meta.assigment_options = payload.meta.assigment_options
    state.data.rentroll.data.mapping = payload.mapping
}

const SET_UPDATE_MAPPING = state => {
    state.data.rentroll.remapping = true
}

const RESET_UPDATE_MAPPING = state => {
    state.data.rentroll.remapping = false
}

const SET_IMPORTING = state => {
    state.importing = true
}

const RESET_IMPORTING = state => {
    state.importing = false
}

const IMPORT_SUCCESSFUL = state => {
    state.importSuccess = true
}

export default {
    RESET_STATE,
    CHANGE_STEP,
    SET_CONTEXT,
    SET_IMPORTING,
    UPLOAD_FAILED,
    SET_FILE_DATA,
    SET_UPLOADING,
    UPLOAD_SUCCESS,
    RESET_IMPORTING,
    RESET_UPLOADING,
    SET_UPLOAD_ERROR,
    IMPORT_SUCCESSFUL,
    SET_ANALYSIS_DATA,
    CHANGE_ACTIVE_ITEM,
    SET_ANALYSIS_ERROR,
    SET_IMPORT_SUCCESS,
    UPDATE_FILTER_VALUE,
    RESET_ANALYSIS_STATE,
    SET_ANALYSIS_LOADING,
    TOGGLE_INPUT_BINDINGS,
    SET_CURRENT_TIMEFRAME,
    UPDATE_LINE_ITEM_VALUE,
    RESET_ANALYSIS_LOADING,
    REQUEST_FILE_ASSISTANCE,
    SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE,
    UPDATE_ANNUALIZED_AMOUNTS,

    // Rent Roll Mutations
    CHANGE_TAB,
    PAGINATE_LAST,
    PAGINATE_FIRST,
    LOAD_NEW_MAPPING,
    PAGINATE_FORWARD,
    PAGINATE_BACKWARD,
    SET_UPDATE_MAPPING,
    RESET_UPDATE_MAPPING
}



// WEBPACK FOOTER //
// ./src/state/modules/importer/mutations.js